import { download } from "../utils/api";

const INVOICE_PDF_STATUSES = new Set([
  "bill_generated",
  "paid",
  "packing",
  "shipment",
  "delivered",
  "recieved",
]);

function orderPathSegment(orderId) {
  const id = orderId == null ? "" : String(orderId).trim();
  if (!id || id === "undefined" || id === "null") return null;
  return encodeURIComponent(id);
}

function parseFilenameFromDisposition(headerValue, fallback) {
  if (!headerValue) return fallback;
  const match = /filename="?([^";]+)"?/i.exec(headerValue);
  return match?.[1] || fallback;
}

export function canDownloadOrderInvoice(order) {
  if (!order) return false;
  const status = String(order.order_status || "").toLowerCase();
  if (!INVOICE_PDF_STATUSES.has(status)) return false;
  // PDF is only available after admin sends the final bill to the customer.
  return order.is_finalized === true || Boolean(order.final_update_sent_at);
}

export function resolveInvoiceFilename(order) {
  const invoiceNo =
    (order?.invoice_id && String(order.invoice_id).trim()) ||
    order?.order_number ||
    `INV-${String(order?.id || "draft").slice(0, 8)}`;
  return `${String(invoiceNo).replace(/[^\w-]+/g, "_")}.pdf`;
}

export async function downloadOrderInvoicePdf(order, options = {}) {
  if (!order?.id) throw new Error("Order is required");
  if (!canDownloadOrderInvoice(order)) {
    throw new Error("Invoice is not available for this order status");
  }

  const seg = orderPathSegment(order.id);
  if (!seg) throw new Error("Order id is missing");

  const path = options.isAdmin
    ? `/admin/order/${seg}/invoice-pdf`
    : `/order/${seg}/invoice-pdf`;

  const response = await download(path);
  const blob = new Blob([response.data], { type: "application/pdf" });
  const filename = parseFilenameFromDisposition(
    response.headers?.["content-disposition"],
    resolveInvoiceFilename(order)
  );

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function previewOrderInvoicePdf(order, options = {}) {
  if (!order?.id) throw new Error("Order is required");
  const seg = orderPathSegment(order.id);
  if (!seg) throw new Error("Order id is missing");

  const path = options.isAdmin
    ? `/admin/order/${seg}/invoice-pdf`
    : `/order/${seg}/invoice-pdf`;

  const response = await download(path);
  const blob = new Blob([response.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");
  setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
}
